// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/cardPayBlock/stylesheets/cardPayBlock.scss
 ** module id = 403
 ** module chunks = 1
 **/